import { createFileRoute } from "@tanstack/react-router";
import { sanitizeHtml } from "@/lib/sanitize";
import { privacyHtml } from "@/data/legalPages";
import { buildCanonical } from "@/lib/canonical-url";
import { PageHero } from "@/components/PageHero";
import pageCover from "@/assets/kupish/p-zasebnost.webp";

export const Route = createFileRoute("/zasebnost")({
  head: () => {
    const url = buildCanonical("/zasebnost");
    const title = "Politika zasebnosti in piškotkov — kupish.si";
    const description =
      "Kako kupish.si obdeluje osebne podatke kupcev in prodajalcev: katere podatke zbiramo, zakaj, kako dolgo jih hranimo ter kakšne pravice imate.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: Page,
});

function Page() {
  return (
    <article className="pb-24">
      <PageHero src={pageCover} alt="Zasebnost na kupish.si — minimalističen 3D prikaz varovanja podatkov">
        <h1 className="font-serif text-4xl md:text-6xl leading-[1.05] tracking-tight">
          Politika <span className=" text-accent">zasebnosti</span> in piškotkov
        </h1>
        <p className="mt-5 text-sm text-muted-foreground">
          Upravljavec platforme: ARTEPIN, spletne rešitve, d.o.o., Šišenska cesta 17, 1000 Ljubljana - SI.
        </p>
      </PageHero>

      <div className="mx-auto max-w-3xl px-6 mt-14 md:mt-20">
        <div className="article-prose" dangerouslySetInnerHTML={{ __html: sanitizeHtml(privacyHtml) }} />
      </div>
    </article>
  );
}
